export interface RenderableComponent {
  _id: string;
  componentName: string;
  description: string;
}

export interface Argument {
  name: string;
  type: "string" | "number" | "boolean" | "url";
  description: string;
  required: boolean;
  default?: string | number | boolean;
}

export interface FunctionDefinition {
  _id: string;
  functionName: string;
  description: string;
  args: Argument[];
}

export const DISPLAY_CONTEXT_ALL = 'all' as const;

export const DISPLAY_CONTEXT_OPTIONS = [
  { value: DISPLAY_CONTEXT_ALL, label: 'All cases (every NBA)' },
  { value: 'new_user', label: 'New users NBA' },
  { value: 'returned_user', label: 'Returned users NBA' },
] as const;

export type DisplayContext = typeof DISPLAY_CONTEXT_OPTIONS[number]['value'];

export interface Action {
  id: string;
  clientId: string;
  name: string;
  order: number;
  description?: string;
  motivation?: string;
  displayContext?: DisplayContext[];
  conditions: Record<string, any>;
  content: any[];
  onActionCallIdentifier: string;
  renderAnotherComponent?: string;
  args?: Record<string, any>;
}

export type ActionByKeyEntry = {
  milestoneName: string;
  stepName: string;
  action: Action;
};

export interface Step {
  id: string;
  clientId: string;
  name: string;
  order: number;
  actions: Action[];
}

export interface Milestone {
  id: string;
  clientId: string;
  name: string;
  label: string;
  order: number;
  isDisabled?: boolean;
  iconId?: string | null;
  steps: Step[];
}

export type ConditionType =
  | "boolean"
  | "sponsored_trial_nct_numbers"
  | "sponsored_treatment_nct_numbers";

export type ConditionFormatter = (value: any) => string | null;

export interface ConditionDefinition {
  key: string;
  label: string;
  description?: string;
  type: ConditionType;
  formatSummary?: ConditionFormatter;
}

export type IconComponentType = React.ComponentType<any>;

export enum IconSource {
  MUI = 'mui',
  CUSTOM = 'custom',
}

export interface IconOption {
  id: string;
  label: string;
  source: IconSource;
  Icon?: IconComponentType;
}
